import { StoryblokFeatureTogggles } from 'src/typings';
import * as ActionTypes from '../ActionTypes';

export const setFeatureTogglesAction = (data: StoryblokFeatureTogggles) => ({
  type: ActionTypes.SET_FEATURE_TOGGLES,
  data,
});
